import axios, { AxiosResponse } from 'axios';
import { CampaignResponse } from '../lib/types';

export const tenantHeader = {
	baseURL: 'https://movedapi-dev.rein.ai/IXCampaign/api',
};

export const $tenantApi = axios.create(tenantHeader);
export class Campaign {
	static getCampaignSettings = (campaignId: string): Promise<AxiosResponse<CampaignResponse>> => {
		return $tenantApi.get(`Campaign/${campaignId}`);
	}
}
interface CampaignApi {
	getCampaignSettings(id: string): Promise<AxiosResponse<CampaignResponse>>
}
export const typedCampaign = Campaign as CampaignApi;
